import { SerializableParam, selectorFamily, useRecoilValue } from 'recoil';
import { DeductionService, PaymentService } from 'services';
import { isAuthenticated, refreshState, useSetRefreshState } from 'state';
import { AttachedDocument, PaymentDetail } from 'types';

type DocumentParams = {
    accountId: string,
    vendorId: string,
    paymentIdRef: string,
    paymentDetail: PaymentDetail,
    fallbackToDeductionDocuments?: boolean,
} & SerializableParam;

export const paymentDocuments = selectorFamily<AttachedDocument[], DocumentParams>({
    key: 'paymentDocuments',
    get: ({ accountId, vendorId, paymentIdRef, paymentDetail, fallbackToDeductionDocuments }) =>
        async ({ get }) => {
            get(refreshState(paymentDocuments({ accountId, vendorId, paymentIdRef, paymentDetail, fallbackToDeductionDocuments }).key))
            if (get(isAuthenticated) && accountId && vendorId && paymentIdRef) {
                const service = new PaymentService();
                const data = await service.getPaymentDocuments(accountId, vendorId, paymentIdRef, paymentDetail);
                return data;
            }
            if (get(isAuthenticated) && accountId && vendorId && paymentDetail.invoiceId && fallbackToDeductionDocuments) {
                const service = new DeductionService();
                const data = await service.getDeductionDocuments(accountId, vendorId, paymentDetail);
                return data;
            }
            return [];
        }
});

export const usePaymentDocuments = (paymentDetail: PaymentDetail) => {
    const { accountId = '', vendorId = '', paymentIdRef = '' } = paymentDetail;
    return useRecoilValue(paymentDocuments({ accountId, vendorId, paymentIdRef, paymentDetail }));
};

export const useRefreshPaymentDocuments = (paymentDetail: PaymentDetail) => {
    const { accountId = '', vendorId = '', paymentIdRef = '' } = paymentDetail;
    return useSetRefreshState(paymentDocuments({ accountId, vendorId, paymentIdRef, paymentDetail }));
};

export const useBillbackDocuments = (paymentDetail: PaymentDetail) => {
    const { accountId = '', vendorId = '', paymentIdRef = '' } = paymentDetail;
    return useRecoilValue(paymentDocuments({
        accountId,
        vendorId,
        paymentIdRef,
        paymentDetail,
        fallbackToDeductionDocuments: true,
    }));
};
